import { ReactNode } from 'react';

import Tooltip from 'components/tooltip/Tooltip';

export interface BetaBadgeProps {
  text?: ReactNode;
  className?: string;
}

export const BETA_DEFAULT_TEXT = (
  <div className="tw-max-w-[280px] tw-text-left tw-text-[12px] tw-leading-[1.5] tw-text-white">
    <p className="tw-mb-2 tw-font-bold tw-uppercase tw-tracking-wider tw-text-[#FF9730]">Bid2Earn — Beta</p>
    <p className="tw-mb-2">
      This is a new feature. It has been tested by our team with no issues found, but has not yet been
      reviewed by third parties.
    </p>
    <p className="tw-mb-2">It may behave differently under high user load.</p>
    <p>
      If you spot any bugs, please report them — your feedback helps us improve the feature. Thanks!
    </p>
    <p className="tw-mt-2 tw-text-[10px] tw-text-white/60">
      Report at{' '}
      <a
        className="tw-text-[#6dfbff] tw-underline"
        href="https://realitymeta.io/contact"
        target="_blank"
        rel="noreferrer"
      >
        contact page
      </a>
    </p>
  </div>
);

export const BetaBadge = ({ text = BETA_DEFAULT_TEXT, className = '' }: BetaBadgeProps) => (
  <Tooltip
    content={text}
    position="bottom"
    className="tw-inline-flex tw-items-center tw-leading-none"
    wrapperClassName="tw-relative tw-inline-flex tw-items-center tw-leading-none"
  >
    <span
      className={`tw-inline-flex tw-items-center tw-rounded-full tw-bg-[#FF9730] tw-px-2 tw-py-[2px] tw-text-[10px] tw-font-bold tw-uppercase tw-leading-none tw-tracking-wider tw-text-white ${className}`}
    >
      Beta
    </span>
  </Tooltip>
);

export default BetaBadge;